import { getConfig } from "lib/get-config";
import { appendTrackingParams } from "lib/tracking/params";

const BACK_URL_KEY_PREFIX = "preAuthBackUrl_";

// После авторизации во фрагменте document.referrer указывает на промежуточную
// страницу редиректа, а не на исходную. Поэтому при загрузке фрагмента сохраняем
// backUrl в sessionStorage, а при следующей загрузке (уже после авторизации)
// восстанавливаем его оттуда.
function resolveBackUrl() {
  const { art, trials, user } = getConfig();

  const key = BACK_URL_KEY_PREFIX + art;
  const saved = sessionStorage.getItem(key);
  if (saved) {
    sessionStorage.removeItem(key);
    return saved;
  }

  let backUrl = `/${art}`;
  const referrer = document.referrer;
  if (referrer) {
    try {
      const referrerUrl = new URL(referrer);
      if (
        referrerUrl.host === window.location.host &&
        referrerUrl.href !== window.location.href
      ) {
        backUrl = referrerUrl.pathname + referrerUrl.search;
      }
    } catch {
      // игнор
    }
  }

  if (trials === 1 && user === 0) {
    sessionStorage.setItem(key, backUrl);
  }

  return backUrl;
}

const backUrl = appendTrackingParams(resolveBackUrl());

export function getBackUrl() {
  return backUrl;
}
